export const SET_FIELD = "UPDATE_FIELD";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_FIELD = "FETCH_FIELD";
export const FETCH_ONE  = "FETCH_ONE";
export const OUTPATIENT_LIST="OUTPATIENT_LIST";
export const CURRENT_VISIT_LIST="CURRENT_VISIT_LIST";
export const BILLING_LIST="BILLING_LIST";
export const INPATIENT_LIST="INPATIENT_LIST";